import React from 'react';
import styled from 'styled-components';
import ImageBlock from '@component/common/block/image-block';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import TextButton from '@design-system/text-button';
import { useAuthPage } from '@hook/auth/useAuth';
import { ETheme } from '@datatype/type';
import gridgioLogo from '@asset/image/gridgio-logo.svg';
import * as color from '@constant/color';
import * as size from '@constant/size';

const Wrapper = styled.div`
  display: flex;
  min-height: 100%;
  padding: ${size.MARGIN_3};
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StartContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 360px;
  flex-direction: column;
  align-items: center;
`;

const AppStart: React.FC = () => {
  const { openAuthPage } = useAuthPage();

  return (
    <Wrapper>
      <StartContainer>
        <ImageBlock src={gridgioLogo} alt='GridGIO' design={{ image: { width: '72px', height: '72px' } }} />
        <Gap height={size.MARGIN_2} />
        <TextBlock text='GridGIO' design={{ text: { size: 'huge', color: color.BLACK_2, bold: true } }} />
        <Gap height={size.MARGIN_2} />
        <TextBlock text='도면과 현장을 연결하는 작업 공간' design={{ text: { size: 'large', color: color.BLACK_2, bold: true } }} />
        <Gap height={size.MARGIN_1} />
        <TextBlock text='도면을 불러오고, 현장의 기록을 한곳에 모으세요.' design={{ text: { size: 'medium', color: color.GRAY_1 } }} />
        <Gap height={size.MARGIN_3} />
        {/* TODO: 오프라인 모드 지원 시 로그인/오프라인 시작을 선택하는 버튼을 제공한다. */}
        <TextButton
          text='로그인하고 시작하기'
          theme={ETheme.CYAN}
          size='large'
          shape='pill'
          width='100%'
          handleClick={() => openAuthPage('signin')}
        />
      </StartContainer>
    </Wrapper>
  );
};

export default AppStart;
